/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GetOrganizationPaymentBillingInfoResponseDataFromJSON, GetOrganizationPaymentBillingInfoResponseDataToJSON } from './GetOrganizationPaymentBillingInfoResponseData';
export function GetOrganizationPaymentBillingInfoResponseFromJSON(json) {
    return GetOrganizationPaymentBillingInfoResponseFromJSONTyped(json, false);
}
export function GetOrganizationPaymentBillingInfoResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        status: json['status'],
        data: GetOrganizationPaymentBillingInfoResponseDataFromJSON(json['data'])
    };
}
export function GetOrganizationPaymentBillingInfoResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        status: value.status,
        data: GetOrganizationPaymentBillingInfoResponseDataToJSON(value.data)
    };
}
